import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

document.documentElement.classList.add('h-full');
document.documentElement.classList.add('bg-gray-50');
document.body.classList.add('h-full');
document.body.classList.add('overflow-hidden');
document.getElementById('root').classList.add('h-full');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
